<template lang="pug">
	modal(max-width="400", v-if="emisora")
		.card
			.card-header
				span.fa.fa-edit.mr-2
				| Editar emisora
				button.close(type='button' aria-label='Close' @click='cerrar')
					span(aria-hidden='true') &times;
			.card-body
				.form-group
					label Nombre
					input.form-control(v-model="emisora.nombre", placeholder="Escribe el nomre")
			.card-footer
				button.btn.btn-primary(@click="guardar")
					span.fa.fa-save.mr-2
					| Guardar
</template>


<script>
import axios from 'axios'

export default {
	props: ['idEmisora'],
	data () {
		return {
			emisora: null
		}
	},
	created () {
		if (this.idEmisora === 'nueva') {
			this.nueva()
		} else {
			axios.get('/gestion-egm/php/api/get-emisora.php?ID_emisora=' + this.idEmisora)
				.then(res => {
					this.emisora = res.data.emisora
				})
				.catch(this.$responseError)
		}
	},
	methods: {
		nueva () {
			this.emisora = {
				ID_emisora: null,
				nombre: null,
				logo: null,
				grupo_ID: null
			}
		},
		guardar () {
			axios.post('/gestion-egm/php/api/set-emisora.php', this.emisora)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Emisora guardada',
						mensaje: 'Se ha guardado correctamente'
					})
					this.cerrar()
				})
				.catch(this.$responseError)
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-egm/vue/components/nueva-emisora.vue